// 六能力域定义与优序图法权重（文档 5.4 节，权重和 = 1.000）
// critical 为关键能力域：处于 1 档时综合等级封顶 L1（文档 5.5 节木桶原理）
export const DOMAINS = [
  {"id": "strategy", "name": "数据战略与组织", "shortName": "战略与组织", "weight": 0.111, "critical": false},
  {"id": "security", "name": "数据安全与合规", "shortName": "安全与合规", "weight": 0.194, "critical": true},
  {"id": "arch", "name": "数据架构与运维", "shortName": "架构与运维", "weight": 0.278, "critical": false},
  {"id": "quality", "name": "数据质量管理", "shortName": "质量管理", "weight": 0.278, "critical": false},
  {"id": "value", "name": "数据应用与价值", "shortName": "应用与价值", "weight": 0.111, "critical": false},
  {"id": "bim", "name": "特定领域与场景", "shortName": "特定领域与场景", "weight": 0.028, "critical": true},
]

// 默认权重（企业级固定使用）
export const DEFAULT_WEIGHTS = {
  "strategy": 0.111,
  "security": 0.194,
  "arch": 0.278,
  "quality": 0.278,
  "value": 0.111,
  "bim": 0.028,
}

// 关键能力域 id 列表
export const CRITICAL_DOMAINS = DOMAINS.filter((d) => d.critical).map((d) => d.id)
